<mat-card class="reg-card-wrap" [matTooltip]="getTooltip()">
  <div class="">

    <div class="bluedashboard-main">

      <div class="Tile-wordings">
        <div class="bluedashboard-spanCardValue">{{
          cardValue
          }}</div>
        <div class="Tile-name">{{
          cardName
          }}</div>
      </div>

      <div class="Card-icon">
        <img [ngClass]="{
      'Card-icon-inner-gigaguru': cardIcon === Icon,
      'Card-icon-inner': cardIcon !== Icon
    }" alt="Supplier" [src]=cardIcon>
      </div>



    </div>

  </div>

</mat-card>
